module.exports = __webpack_public_path__ + "img/main_menu_hover_1.d4a8540b.png";